import { post } from "../axios/index";
export default {
  PUSH_INCLUDE: ({ commit }, String) => {
    commit("PUSH_INCLUDE", String);
  },
  PUSH_AXIOS_PING: ({ commit }, Obj) => {
    commit("PUSH_AXIOS_PING", Obj);
  },
  REMOVE_AXIOS_PING: ({ commit }, Index) => {
    commit("REMOVE_AXIOS_PING", Index);
  },
  LOADING_SHOW: ({ commit }, Boolean) => {
    commit("LOADING_SHOW", Boolean);
  },
  SET_BACK_FLAG: ({ commit }, Boolean) => {
    commit("SET_BACK_FLAG", Boolean);
  },
  SET_LANGUAGE: ({ commit }, String = "") => {
    commit("SET_LANGUAGE", String);
  },
  SET_TOKEN: ({ commit }, String = "") => {
    commit("SET_TOKEN", String);
  },
  // GET_PLATFORM_INFO: ({ commit }, { obj } = {}) => {
  //   commit("GET_PLATFORM_INFO", obj)
  // },
  GET_PLATFORM_INFO: ({ commit }) => {
    // 处理异步请求的, 处理平台信息
    return new Promise(() => {
      post("/app/index/webhome", {}, { loading: true }).then(res => {
        commit("GET_PLATFORM_INFO", res);
      });
    });
  },
  GET_USER_INFO: ({ commit }, { obj } = {}) => {
    // 处理异步请求的，处理用户信息
    if (obj) {
      commit("GET_USER_INFO", obj);
    } else {
      return new Promise(() => {
        post("/app/user/userInfo", {}, { loading: true }).then(function(res) {
          commit("GET_USER_INFO", res);
        });
      });
    }
  },
  SET_MONEY: ({ commit }, bol) => {
    // 处理异步请求的，钱   bol 等於object 直接賦值 等于 boolean 返回状态
    if (typeof bol == "object") {
      commit("SET_MONEY", bol);
      return false;
    }
    return new Promise(resolve => {
      post("/app/user/getUserAccount", {}).then(res => {
        if (bol) {
          resolve(res);
        }
        commit("SET_MONEY", res);
      });
    });
  }
};
